<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card
    class="pa-2 d-flex flex-column justify-end"
    color="grey lighten-5"
    elevation="0"
    style="position:relative"
    tile
  >
    <apex-chart
      v-if="graphIsReady"
      :options="options"
      :series="series"
      height="400"
      type="bar"
    />
  </v-card>
</template>
<script>

export default {
  name: 'OrderTimeChart',
  props: {
    dailyInfo: {}
  },
  data: function () {
    return {
      series: [],
      options: {},
      graphIsReady: false
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph: async function () {
      this.graphIsReady = false
      const data = this.dailyInfo.map(it => {
        return {
          x: it.halfHours / 2 + 'H',
          y: it.orderCount
        }
      })
      this.series = [
        {
          data
        }
      ]

      this.options = {
        fill: {
          colors: [
            '#8a8a8a',
            '#3a3a3a',
            '#bababa',
            '#fbdc46'
          ]
        },
        plotOptions: {
          bar: {
            columnWidth: '90%',
            distributed: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }

        },

        grid: {
          show: false
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true
        },
        xaxis: {
          type: 'category',
          labels: {
          },
          axisTicks: {
            show: false
          }
        }

      }
      this.graphIsReady = true
    }
  }
}
</script>

<style scoped>

</style>
